import React from 'react';
import classNames from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';
import SectionTitle from '@/ui/SectionTitle/SectionTitle';
import SliderWrapper from '@/ui/SliderWrapper/SliderWrapper';
import { BrandArrow } from '@/icons/index';
import {
  Tab,
  TabContent,
  TabContentItem,
  TabPanel,
  Tabs,
  TariffCard,
  Button,
} from '@/ui/index';
import { ComponentVariants } from '@/enums/button';
import useSlickPositioning from '@/hooks/useSlickPositioning';

import styles from './styles.module.scss';

const Tariffs = ({ data, title, buttonText, onClick = () => null }) => {
  const [currentTab, setCurrentTab] = React.useState(0);
  const [currentTag, setCurrentTag] = React.useState(data?.tags?.[0] || null);

  const { lang } = useTranslation();
  const router = useRouter();

  useSlickPositioning();

  const tariffList = data?.tariffs?.filter((element) =>
    element?.tags?.some((child) => child?.id === currentTag?.id),
  );

  const handleEventAction = (tariff) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'view_item',
      ecommerce: {
        currency: 'AZN',
        items: [
          {
            item_id: tariff?.ngbss_id,
            item_name: tariff?.name,
            price: tariff?.price,
            quantity: 1,
            item_category: 'Subscription',
          },
        ],
      },
    });
  };

  const renderSlider = (tariff, index) => {
    const isHomePage = router.asPath === '/';
    const isAzerbaijani = lang === 'az';

    const updatedTariff = isHomePage
      ? {
          ...tariff,
          button_slug: isAzerbaijani
            ? tariff.button_slug
            : `${lang}/${tariff?.button_slug}`,
        }
      : tariff;
    return (
      <div className={styles.sliderItem} key={index}>
        <TariffCard
          item={updatedTariff}
          onClick={() => handleEventAction(updatedTariff)}
        />
      </div>
    );
  };

  if (!data?.tags || data.tags.length === 0) {
    return (
      <div
        className={classNames('wrapper', 'section', styles.tariffSliderWrapper)}
        itemScope
        itemType='https://schema.org/Offer'
      >
        <SectionTitle
          icon={data?.icon}
          href={data?.button_slug}
          buttonText={data?.button_text}
          buttonVariant={ComponentVariants.router}
        >
          {title}
        </SectionTitle>
        <div className={styles.panner}>
          <SliderWrapper
            arrows
            nextArrow={<BrandArrow width={17} />}
            prevArrow={<BrandArrow width={17} />}
            options={{ infinite: data?.tariffs?.length >= 3 }}
          >
            {data?.tariffs?.map(renderSlider)}
          </SliderWrapper>
        </div>
        {data?.button_text && (
          <Button
            href={data?.button_slug}
            Component={data?.button_slug ? 'router' : 'button'}
            onClick={onClick}
            size='normal'
            variant={ComponentVariants.router}
            className={classNames(styles.button, styles.buttonTariffsMobile)}
          >
            {data?.button_text}
          </Button>
        )}
      </div>
    );
  }

  const renderTab = (item, index) => (
    <Tab
      key={index}
      onClick={() => {
        setCurrentTab(index);
        setCurrentTag(item);
      }}
      itemScope
      itemType='https://schema.org/ListItem'
    >
      {item?.text}
    </Tab>
  );

  const renderTabItem = (item, index) => (
    <TabContentItem
      key={index}
      itemScope
      itemType='https://schema.org/ListItem'
    >
      {data?.tariffs?.length > 0 && (
        <SliderWrapper
          arrows
          nextArrow={<BrandArrow width={17} />}
          prevArrow={<BrandArrow width={17} />}
          options={{ infinite: tariffList?.length > 3 }}
        >
          {tariffList?.map(renderSlider)}
        </SliderWrapper>
      )}
    </TabContentItem>
  );

  return (
    <div
      className={classNames('wrapper', 'section', styles.tariffSliderWrapper)}
      itemScope
      itemType='https://schema.org/ItemList'
    >
      <SectionTitle
        icon={data?.icon}
        onClick={onClick}
        href={data?.button_slug}
        buttonText={buttonText}
        buttonVariant={'router'}
      >
        {title}
      </SectionTitle>
      <Tabs active={currentTab}>
        <TabPanel className={`${styles.panner} wrapper`}>
          {data?.tags?.map(renderTab)}
        </TabPanel>
        <TabContent>{data?.tags?.map(renderTabItem)}</TabContent>
      </Tabs>
    </div>
  );
};

export default Tariffs;
